import Image from "next/image";
import Link from "next/link";

const ImmediateImpact = ({ head, subhead, imgUrl, imgAlt, buttonText }) => {
  return (
    <section className="immediate-impact full">
      <div className="immediate-impact__banner banner">
        <div className="immediate-impact__copy">
          <Image src={imgUrl} alt={imgAlt} width={90} height={90} />
          <div className="section-header">
            <h3 className="heading heading--md"> {head} </h3>
          </div>
          <h6 className="heading heading--xxs"> {subhead} </h6>
          <Link
            id="button_immediate_impact-apply-now"
            href="https://jobs.lever.co/teamshares?department=Teamshares&team=President%20Network"
            className="ts-button body body--md"
            target="_blank"
          >
            {buttonText}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ImmediateImpact;
